import React from "react";
import "./MiniCard.css";

interface MiniCardProps {
  header: string;
  subHeader: string;
  desc: string;
  onViewMore?: () => void;
}

const MiniCard: React.FC<MiniCardProps> = ({
  header,
  subHeader,
  desc,
  onViewMore,
}) => (
  <div className="mini-card">
    <div className="mini-card-header">{header}</div>
    <div className="mini-card-subheader">{subHeader}</div>
    <div className="mini-card-desc">{desc}</div>
    <button className="mini-card-btn" onClick={onViewMore}>
      View More
    </button>
  </div>
);

export default MiniCard;
